import { formatDate } from '@angular/common';
import { OnInit, Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, _MatTableDataSource } from '@angular/material/table';
import { catchError, finalize, tap, throwError } from 'rxjs';
import { ApiservicesService } from 'src/app/apiservices.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ArrayDataSource } from '@angular/cdk/collections';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-carian-hubungan',
  templateUrl: './carian-hubungan.component.html',
  styleUrls: ['./carian-hubungan.component.css']
})
export class CarianHubunganComponent implements OnInit {

  //UI View Variables
  TIN: any = "";
  fileType: any = "";
  compName: any = "";
  dateCreated: any = "";
  status: any = "";
  jenisFirma: any = "";
  nameBranch: any = "";
  namaEjen: any = "";
  displayedColumnsFirma = ['TIN', 'fileType', 'compName', 'dateCreated', 'status', 'jenisFirma', 'nameBranch']; //, 'agentName'
  displayedColumnsEjen = ['firmID', 'namaFirma', 'JenisFile', 'tin', 'noPendaftaran', 'tarikhDaftar'];


  //Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";
  displayEjenStatus: boolean = false;

  //UI Tree Variables
  TreeNode: any[] = [];
  TreeNodeFirm: any[] = [];

  //Session Variables
  FirmIDSession: any = "";

  LoaderStatus: boolean = false;

  treeControl = new FlatTreeControl<any>(
    node => node.level,
    node => node.expandable,
  );

  dataSource = new ArrayDataSource(this.TreeNode);
  dataSourceFirm = new ArrayDataSource(this.TreeNodeFirm);
  hasChild = (_: number, node: any) => node.expandable;

  constructor(private apiServices: ApiservicesService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }
  ngOnInit(): void {
    this.top.updateTotal();
    this.FirmIDSession = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.GetFirmRelationship(this.FirmIDSession);
  }
  ResetValue() {
    this.displayEjenStatus = false;
    this.AlertType = "";
    this.AlertStatus = false;
    this.AlertMessage = "";

    this.LoaderStatus = false;
  }

  getParentNode(node: any) {
    const nodeIndex = this.TreeNode.indexOf(node);

    for (let i = nodeIndex - 1; i >= 0; i--) {
      if (this.TreeNode[i].level === node.level - 1) {
        return this.TreeNode[i];
      }
    }
    return null;
  }
  shouldRender(node: any) {
    let parent = this.getParentNode(node);
    while (parent) {
      if (!parent.isExpanded) {
        return false;
      }
      parent = this.getParentNode(parent);
    }
    return true;
  }

  getParentNodeFirm(node: any) {
    const nodeIndex = this.TreeNodeFirm.indexOf(node);

    for (let i = nodeIndex - 1; i >= 0; i--) {
      if (this.TreeNodeFirm[i].level === node.level - 1) {
        return this.TreeNodeFirm[i];
      }
    }
    return null;
  }
  shouldRenderFirm(node: any) {
    let parent = this.getParentNodeFirm(node);
    while (parent) {
      if (!parent.isExpanded) {
        return false;
      }
      parent = this.getParentNodeFirm(parent);
    }
    return true;
  }

  async GetAgentRelationship(FirmID: any) {
    this.LoaderStatus = true;
    this.TreeNode = [];
    const result = await this.apiServices.GetHubunganEjenStaff(FirmID);
    this.TreeNode.push({
      name: result[0].nameFirma,
      expandable: true,
      level: 0,
      role:"Firm"
    },);
    result[0].ejen.forEach((currentValue: any, index: any) => {
      if (result[0].ejen[index].penyelia.length > 0) {
        this.TreeNode.push({
          name: result[0].ejen[index].nama + " (Ejen Cukai) (" + result[0].ejen[index].noPengenalan + ")",
          expandable: true,
          level: 1,
          role: "Ejen Cukai"
        },);
        result[0].ejen[index].penyelia.forEach((currentValue: any, index2: any) => {
          if (result[0].ejen[index].penyelia[index2].staff.length > 0) {
            this.TreeNode.push({
              name: result[0].ejen[index].penyelia[index2].nama + " (Penyelia) (" + result[0].ejen[index].penyelia[index2].noPengenalan + ")",
              expandable: true,
              level: 2,
              role: "Penyelia"
            });
            result[0].ejen[index].penyelia[index2].staff.forEach((currentValue: any, index3: any) => {
              this.TreeNode.push({
                name: result[0].ejen[index].penyelia[index2].staff[index3].nama + " (Staf) (" + result[0].ejen[index].penyelia[index2].staff[index3].noPengenalan + ")",
                expandable: false,
                level: 3,
                role: "Staf"
              });
            });
          } else {
            this.TreeNode.push({
              name: result[0].ejen[index].penyelia[index2].nama + " (Penyelia) (" + result[0].ejen[index].penyelia[index2].noPengenalan + ")",
              expandable: false,
              level: 2,
              role: "Penyelia"
            });
          }
        });
      } else if (result[0].ejen[index].staff.length > 0) {
        result[0].ejen[index].staff.forEach((currentValue: any, index2: any) => {
          this.TreeNode.push({
            name: result[0].ejen[index].nama + " (Ejen Cukai) (" + result[0].ejen[index].noPengenalan + ")",
            expandable: true,
            level: 1,
            role: "Ejen Cukai"
          });

          result[0].ejen[index].staff.forEach((currentValue: any, index2: any) => {
            this.TreeNode.push({
              name: result[0].ejen[index].staff[index2].nama + " (Staff) (" + result[0].ejen[index].staff[index2].noPengenalan + ")",
              expandable: false,
              level: 2,
              role: "Staf"
            });
          });

        });
      } else {
        this.TreeNode.push({
          name: result[0].ejen[index].nama + " (Ejen Cukai) (" + result[0].ejen[index].noPengenalan + ")",
          expandable: false,
          level: 1,
          role: "Ejen Cukai"
        },);
      }
    });

    result[0].penyelia.forEach((currentValue: any, index: any) => {
      if (result[0].penyelia[index].staff.length > 0) {
        this.TreeNode.push({
          name: result[0].penyelia[index].nama + " (Penyelia) (" + result[0].penyelia[index].noPengenalan + ")",
          expandable: true,
          level: 1,
          role: "Penyelia"
        });

        result[0].penyelia[index].staff.forEach((currentValue: any, index2: any) => {
          this.TreeNode.push({
            name: result[0].penyelia[index].staff[index2].nama + " (Staff) (" + result[0].penyelia[index].staff[index2].noPengenalan + ")",
            expandable: false,
            level: 2,
            role: "Staf"
          });
        });

      } else {
        this.TreeNode.push({
          name: result[0].penyelia[index].nama + " (Penyelia) (" + result[0].penyelia[index].noPengenalan + ")",
          expandable: false,
          level: 1,
          role: "Penyelia"
        });
      }
    });

    result[0].staff.forEach((currentValue: any, index: any) => {
      this.TreeNode.push({
        name: result[0].staff[index].nama + " (Staff) (" + result[0].staff[index].noPengenalan + ")",
        expandable: false,
        level: 1,
        role: "Staf"
      });
    });

    this.dataSource = new ArrayDataSource(this.TreeNode);
    this.LoaderStatus = false;
  }
  async GetFirmRelationship(FirmID: any) {
    this.LoaderStatus = true;
    var F = parseInt(FirmID);
    this.TreeNodeFirm = [];
    const result = await this.apiServices.GetFirmRelationship(F);
    this.TreeNodeFirm.push({
      name: result.firm.name,
      expandable: true,
      level: 0,
      role: "Firm"
    });

    result.admin.forEach((currentValue: any, index: any) => {
      this.TreeNodeFirm.push({
        name: result.admin[index].staffName + " (Pentadbir) (" + result.admin[index].staffIDNo + ")",
        expandable: false,
        level: 1,
        role: "Pentadbir"
      });
    });

    result.agent.forEach((currentValue: any, index: any) => {
      this.TreeNodeFirm.push({
        name: result.agent[index].staffName + " (Ejen Cukai) (" + result.agent[index].staffIDNo + ")",
        expandable: false,
        level: 1,
        role: "Ejen"
      });
    });

    result.supervisor.forEach((currentValue: any, index: any) => {
      this.TreeNodeFirm.push({
        name: result.supervisor[index].staffName + " (Penyelia) (" + result.supervisor[index].staffIDNo + ")",
        expandable: false,
        level: 1,
        role: "Penyelia"
      });
    });

    result.staff.forEach((currentValue: any, index: any) => {
      this.TreeNodeFirm.push({
        name: result.staff[index].staffName + " (Staf) (" + result.staff[index].staffIDNo + ")",
        expandable: false,
        level: 1,
        role: "Staf"
      });
    });
    this.dataSourceFirm = new ArrayDataSource(this.TreeNodeFirm);
    this.LoaderStatus = false;
  }
}
